export const pagination = {
    data() {
        return {
          currentPage: 1,
          totalPages: 0,
          pageSize: 15,
        }
    },
    methods: {

    }
  }